// extracted by mini-css-extract-plugin
export default {"invalid":"Plataformas_invalid__k5Px2","spinnerContainer":"Plataformas_spinnerContainer__KiK66"};